// Botones de pago del carrito.
// "Yape o Plin" (data-pay-wa): arma el pedido con el precio Yape (-6%) y las opciones de envío, y lo abre en el WhatsApp de Servissana.
// "Tarjeta" (data-pay + data-discount=""): quita cualquier código y va al checkout de Shopify (ahí elige el envío).
// Siempre parte del precio SIN descuentos (original_*) para no restar el 6% dos veces.
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const fmt = document.documentElement.dataset.moneyFormat || 'S/ {{amount}}';
  const money = (c) => fmt.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  const yape = (c) => Math.round(c * 0.94);
  const GRATIS_DESDE = 9900;
  const ENVIOS = [
    ['Lima rápido (24 h)', 1400],
    ['Lima económico (2-3 días)', 1000],
    ['Provincias (Olva o Shalom)', 1500],
  ];

  document.addEventListener('click', async (e) => {
    const wa = e.target.closest('[data-pay-wa]');
    if (wa) {
      e.preventDefault();
      wa.disabled = true;
      try {
        const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        const lines = cart.items.map((it) => {
          const variant = it.variant_title && it.variant_title !== 'Default Title' ? ` (${it.variant_title})` : '';
          return `• ${it.quantity} × ${it.product_title}${variant} – ${money(yape(it.original_line_price))}`;
        });
        const total = yape(cart.original_total_price);
        const envio = total >= GRATIS_DESDE
          ? ['Envío: GRATIS (pedido desde ' + money(GRATIS_DESDE) + ')']
          : ['Envío (marca una opción):', ...ENVIOS.map(([n, p]) => `▢ ${n}: ${money(p)} → total ${money(total + p)}`)];
        const msg = [
          'Hola Servissana, quiero hacer este pedido:',
          '',
          ...lines,
          '',
          `Productos con Yape o Plin (6% menos): ${money(total)}`,
          ...envio,
          '',
          'Método de pago: Yape o Plin',
          'Envío a (distrito / ciudad): ',
        ].join('\n');
        location.href = `${wa.dataset.payWa}?text=${encodeURIComponent(msg)}`;
      } catch (err) {
        location.href = wa.dataset.payWa;
      } finally {
        wa.disabled = false;
      }
      return;
    }

    const btn = e.target.closest('[data-pay][data-discount]');
    if (!btn || !btn.form) return;
    e.preventDefault();
    btn.disabled = true;
    const code = btn.dataset.discount;
    try {
      await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Método de pago preferido': btn.dataset.pay }, discount: code }),
      });
    } catch (err) {
      // si falla, igual seguimos al checkout
    }
    location.href = root + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
  });
})();
